"use client";

import { c as _c } from "react/compiler-runtime";
import { IconCircleCheck } from "central-icons/IconCircleCheck";
import { IconCircleX } from "central-icons/IconCircleX";
import { AnimatePresence, m } from "motion/react";
import { useState } from "react";
import DemoFooter from "@/components/preview/demo-footer";
import DemoWrapper from "@/components/preview/demo-wrapper";
import { Button } from "@/components/ui/button";
import { IconBadge } from "@/components/ui/icon-badge";
import { cn } from "@/lib/utils";
import { SLIDE_HEIGHT } from "./slide-height";
type ExitMode = "soft" | "full";
function ExitVariant(t0) {
  const $ = _c(23);
  const {
    mode,
    isOpen,
    onClose
  } = t0;
  const isSoft = mode === "soft";
  const t1 = isSoft && "border-t sm:border-t-0 sm:border-l";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex h-full min-h-0 flex-col border-preview-border", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isOpen || $[3] !== onClose) {
    t3 = isOpen && <m.div animate={{
      opacity: 1
    }} className="absolute inset-0 z-10 size-full bg-preview-bg" exit={{
      opacity: 0
    }} initial={{
      opacity: 0
    }} key="backdrop" onClick={onClose} transition={{
      bounce: 0,
      duration: 0.45,
      type: "spring"
    }} />;
    $[2] = isOpen;
    $[3] = onClose;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isOpen || $[6] !== isSoft) {
    t4 = isOpen && <m.div animate={{
      filter: "blur(0px)",
      opacity: 1,
      x: 0
    }} className={cn("absolute inset-y-1 z-20 flex w-52 flex-col gap-1 rounded-lg bg-gray-100 p-1 shadow-custom", isSoft ? "right-1" : "left-1")} exit={{
      filter: isSoft ? "blur(4px)" : "blur(0px)",
      opacity: isSoft ? 0 : 1,
      x: isSoft ? "70%" : "calc(-100% - 4px)"
    }} initial={{
      filter: "blur(0px)",
      opacity: 1,
      x: isSoft ? "calc(100% + 4px)" : "calc(-100% - 4px)"
    }} key="menu" transition={{
      bounce: 0,
      duration: 0.45,
      type: "spring"
    }} />;
    $[5] = isOpen;
    $[6] = isSoft;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <AnimatePresence initial={false} mode="popLayout">{t4}</AnimatePresence>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = isSoft ? "left-3.5" : "right-3.5";
  let t7;
  if ($[10] !== t6) {
    t7 = cn("absolute bottom-3.5 z-30 size-8", t6);
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = isSoft ? "sky" : "gray";
  const t9 = isSoft ? IconCircleCheck : IconCircleX;
  let t10;
  if ($[12] !== t7 || $[13] !== t8 || $[14] !== t9) {
    t10 = <IconBadge className={t7} color={t8} icon={t9} />;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t3 || $[18] !== t5) {
    t11 = <div className="relative flex h-full w-full items-center justify-center overflow-hidden">{t3}{t5}{t10}</div>;
    $[16] = t10;
    $[17] = t3;
    $[18] = t5;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t2) {
    t12 = <div className={t2}>{t11}</div>;
    $[20] = t11;
    $[21] = t2;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
}
export default function ExitAnimation() {
  const $ = _c(6);
  const [isOpen, setIsOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsOpen(false);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleClose = t0;
  let t1;
  if ($[1] !== isOpen) {
    t1 = <div className="grid min-h-0 w-full flex-1 grid-cols-1 grid-rows-2 sm:grid-cols-2 sm:grid-rows-1"><ExitVariant isOpen={isOpen} mode="full" onClose={handleClose} /><ExitVariant isOpen={isOpen} mode="soft" onClose={handleClose} /></div>;
    $[1] = isOpen;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DemoFooter><Button className="shrink-0" onClick={() => {
        setIsOpen(_temp);
      }} size="sm" type="button" variant="secondary">Animate</Button></DemoFooter>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <DemoWrapper height={SLIDE_HEIGHT}>{t1}{t2}</DemoWrapper>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp(open) {
  return !open;
}